export type PostponeDueDateCalculatorResult = {
	defermentFee: number;
	annualInterestRate: number;
	rpsn: number;
};

const MONTHS_IN_YEAR = 12;
const PERCENT_MULTIPLIER = 100;
const FEE_PER_HUNDRED = 3.5;

const roundToTwoDecimals = (value: number): number =>
	Math.round((value + Number.EPSILON) * 100) / 100;

export const calculateFee = (monthSpendings: number, currentPayment: number): number => {
	const postponedAmount = monthSpendings - currentPayment;

	return postponedAmount <= 0 ? 0 : Math.ceil(postponedAmount / 100) * FEE_PER_HUNDRED;
};

export const calculatePostponeDueDateValues = (
	monthSpendings: number,
	currentPayment: number
): PostponeDueDateCalculatorResult => {
	const postponedAmount = monthSpendings - currentPayment;
	const defermentFee = calculateFee(monthSpendings, currentPayment);

	if (postponedAmount <= 0) {
		return {
			defermentFee,
			annualInterestRate: 0,
			rpsn: 0,
		};
	}

	const annualInterestRate = (defermentFee / postponedAmount) * MONTHS_IN_YEAR * PERCENT_MULTIPLIER;
	const annualInterestRateDecimal = annualInterestRate / PERCENT_MULTIPLIER;
	const rpsn =
		((1 + annualInterestRateDecimal / MONTHS_IN_YEAR) ** MONTHS_IN_YEAR - 1) * PERCENT_MULTIPLIER;

	return {
		defermentFee,
		annualInterestRate: roundToTwoDecimals(annualInterestRate),
		rpsn: roundToTwoDecimals(rpsn),
	};
};
